import React from 'react'

import { Button } from '@/components/buttons/Button'

export const ModalActions = ({
  onClose,
  onSubmit,
  buttonLabel,
  closeButtonLabel = 'Cancel',
  isDelete,
  children,
}) => {
  const resolvedButtonLabel = buttonLabel || (isDelete ? 'Delete' : 'Submit')

  const handleSubmit = () => {
    onSubmit()

    if (onClose) {
      onClose()
    }
  }

  return (
    <>
      {children}
      <div className="modal-footer">
        {onClose && (
          <Button data-testid="close-button" onClick={onClose}>
            {closeButtonLabel}
          </Button>
        )}
        <Button
          critical={isDelete}
          brand={!isDelete}
          data-testid="confirm-button"
          onClick={handleSubmit}
        >
          {resolvedButtonLabel}
        </Button>
      </div>
    </>
  )
}
